import React from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Layout } from 'components/Layout';
import { getPageStaticProps } from 'lib/dato-request';
import NewHero from 'components/Homepage/NewHero';
import HowItWorksNew from '@/components/HowItWorks/HowItWorksNew';
import { Trustbar2 } from '@/components/Trustbar2';
import FounderSection from '@/components/Parents/FounderSection';
import TryFree from '@/components/Homepage/TryFree';
import TestimonialListSimple from '@/components/ParentsLandingPage/TestimonialListSimple';
import ImageBarSection from '@/components/Trustbar2/ImageBarSection';

const Home = ({ data }) => {
    const { page, site } = data;
    const { components, seo } = page;

    return (
        <Layout>
            <NextSeo title={seo?.title} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>

            <NewHero
                id='home-hero'
                heading={components[0].heading}
                featuredImage={components[0].featuredImage}
            />

            <FounderSection
                id='parents-founder'
                heading={components[1].heading}
                smallHeading={components[1].smallHeading}
                subhead={components[1].subhead}
                videoLink={components[1].videoLink}
                homepage={true}
                background=' linear-gradient(180deg, #F1E6FE 0%, #FFF 100%)'

            />

            <TryFree id='try-free' images={components[2].gallery} />

            <HowItWorksNew videoLink={components[3].videoLink} id='home-how-it-works' />

            <div className='bg-white pb-10 lg:pb-20 pt-4 sm:pt-12 lg:pt-0 '>
                <TestimonialListSimple sliceNumber={2} testimonials={components[4].testimonials} />
            </div>
            <div className='py-5 lg:py-10' style={{ backgroundImage: 'linear-gradient(180deg, #6171E5 0%, #757ACB 100%)' }}>
                <ImageBarSection images={components[5].gallery} className='my-0 hidden lg:block' />
                <ImageBarSection images={components[5].gallery} className='block lg:hidden mb-4 sm:mb-6 mt-0' />

                <Trustbar2
                    logos={components[6].gallery}
                    bgColor='none'
                    wide={true}
                    className='center-on-medium block md:hidden pb-0 mt-5 '
                    mediumImageMaxWidth='25%'
                    phoneImageMaxWidth='150px'
                    flexWrap='wrap'

                />

                <Trustbar2
                    logos={components[6].gallery}
                    className='center-on-medium hidden md:block  lg:mt-12 mb-6 lg:mb-0'
                    bgColor='none'
                    wide={true}
                    mediumImageMaxWidth='20%'
                    phoneImageMaxWidth='30%'
                />
            </div>
        </Layout>
    );
};

export async function getStaticProps({ preview = false }) {
    return getPageStaticProps('Homepage');
}

export default Home;
